import { useEffect, useState, useCallback } from 'react'
import Box from '@mui/material/Box'
import TextField from '@mui/material/TextField'
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline'
import Autocomplete from '@mui/material/Autocomplete'
import { useFormik } from 'formik'
import * as yup from 'yup'

import api from 'api'
import { DISABLED_BUTTON, PRIMARY_BUTTON } from 'themes/theme'
import CustomButton from 'components/Common/Button'
import { useSelector } from 'react-redux'

import { Checkbox, FormControlLabel } from '@mui/material'
import ConfirmDialog from 'components/Common/Dialog/ConfirmDialog'
import ThreeDotsLoadingSpinner from 'components/Common/LoadingSpinner/threeDots'
import eventBus from "../../utils/eventBus"
import Snackbar from "components/Common/SnackBar";
import ZendeskLink from 'components/Common/ZendeskLink'

const sx = {
  header: {
    padding: '0 0 50px 0',
    h6: {
      color: '#25245F',
    },
    p: {
      color: '#66668F',
      marginTop: '10px',
    },
  },
  list: {
    backgroundColor: '#fff',
    padding: '10px 30px',
    borderRadius: '10px',
    boxShadow: '4px 4px 15px rgba(10, 120, 205, 0.08)',

    '.MuiFormLabel-root': {
      color: '#0A78CD!important',
      transform: 'unset',
      fontSize: '14px',
    },

    '.MuiInput-root:after': {
      border: '0.5px solid #dad6d6',
    },

    '.MuiInput-root': {
      color: '#66668F',
    },
  },
  keyPeople: {
    marginBottom: '50px',
  },
  contactLabel: {
    color: '#25245F',
    margin: '20px 0 10px 0',
    fontWeight: 600,
    fontSize: '14px',
    letterSpacing: '1px',

    borderLine: {
      borderBottom: '2px solid #25245F',
    },
  },

  btnAdd: {
    fontSize: '14px',
    textTransform: 'none',
    color: '#0A78CD',
    backgroundColor: '#F4F4F7',
    borderRadius: '50px',
    lineHeight: '35px',
    border: 'none',
    marginBottom: '10px',
  },

  btnUpdate: {
    width: '120px',
    // marginTop: '50px',
  },

  buttonContact: {
    '.MuiTypography-root': {
      textTransform: 'initial',
    },
  },

  checkboxLabel: {
    '.MuiFormControlLabel-label': {
      fontSize: '14px',
      fontFamily: 'Poppins',
      color: '#0A78CD',
    },
  },
  buttonPlacement: {
    marginTop: '30px',
    display: 'flex',
    justifyContent: 'end',
  },
}

const initialKeyPeople = {
  firstName: '',
  title: '',
  phone: '',
  email: '',
  displayInDirectory: false,
}

const validationSchema = yup.array().of(
  yup.object({
    firstName: yup.string().required('Name is Required'),
    title: yup.string().notRequired(),
    email: yup.string().email('Enter valid email'),
    phone: yup.number().typeError('Enter valid phone number').notRequired(),
  }),
)

export default function Management({ onDataChange }) {
  const [business, setBusiness] = useState(null)
  const [keyPeople, setKeyPeople] = useState([])
  // const [delKeyPeople, setDelKeyPeople] = useState()
  const [selectedRow, setSelectedRow] = useState()
  const [loading, setloading] = useState()
  const [showRemoveConfirmPopup, setShowRemoveConfirmPopup] = useState(false)
  const [titles, setTitles] = useState([])
  const claimedBusiness = useSelector(state => state.apiResponseReducers.dashboardInfo.business_list)
  const [snackData, setSnackData] = useState({
    isOpen: false,
    type: 'success',
    message: ' ',
  })

  const formik = useFormik({
    initialValues: keyPeople,
    onSubmit: async () => {
      await handleSubmit()
    },
    validationSchema,
    enableReinitialize: true,
  })

  useEffect(() => {
    ;(async function () {
      setloading(true)
      const data = await api.getBusinessDetails(claimedBusiness[0]?.mkz_business_id)
      const { titles } = await api.getCompanyTitles('')
      setTitles(titles)
      setBusiness(data)
      setloading(false)
    })()
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (business == null) return
    if (business?.details?.keyPeople) {
      setKeyPeople(business.details.keyPeople)
    }
  }, [business])

  const saveCallback = data => {
    setSnackData(data)
  }

  const handleSubmit = useCallback(async () => {
    const data = {
      keyPeople: formik.values,
      businessId: claimedBusiness[0].mkz_business_id,
    }
    await api.updateMyBusinessKeyPeople(data, res => {
      if (res) {
        saveCallback(res)
      }
    })
    if (data) {
      const res = await api.getBusinessDetails(claimedBusiness[0]?.mkz_business_id)
      setBusiness(res)
    }
    setKeyPeople(formik.values)
    onDataChange(false)
  }, [formik, claimedBusiness, onDataChange])

  useEffect(() => {
    eventBus.on('cyd-tab-change', handleSubmit)
    return function () {
      eventBus.off('cyd-tab-change', handleSubmit)
    }
  }, [handleSubmit])

  function handleChange(fieldName, value) {
    onDataChange(true)
    formik.setFieldValue(fieldName, value)
  }

  function handleAddContact() {
    if (keyPeople.length < 5) {
      setKeyPeople([...formik.values, { ...initialKeyPeople }])
      setBusiness(business)
    }
  }

  function handleDataChange() {
    onDataChange(true)
  }

  const onRemoveContact = (e, item) => {
    setShowRemoveConfirmPopup(true)
    setSelectedRow(item)
  }

  async function deleteHandler() {
    setShowRemoveConfirmPopup(false)
    await api.deleteKeyPeople(selectedRow.keyContactId)
    if (selectedRow.keyContactId) {
      const res = await api.getBusinessDetails(claimedBusiness[0]?.mkz_business_id)
      setBusiness(res)
    }
  }

  return (
    <>
      {loading ? (
        <Box display="flex" justifyContent="center" alignItems="center" height="50vh">
          <ThreeDotsLoadingSpinner width="60px" />
        </Box>
      ) : (
        <Box sx={sx.main}>
          <Grid container>
            <Grid item xs={10.5}>
              <Box sx={sx.header}>
                <Typography variant="h6">Confirm & update your management information</Typography>
                <Typography variant="body2">
                  This page allows you to add the contact information and position titles for up to five contacts of
                  your business to display within Markaaz. Additionally, contacts can be "hidden" if you don't want
                  their information displayed to other users of Markaaz. You can change these restrictions or enter a
                  new contact at anytime.
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={1.5} sx={sx.buttonPlacement}>
              <CustomButton
                submit
                sx={sx.btnUpdate}
                onClick={formik.handleSubmit}
                loading={formik.isSubmitting}
                type={!formik.dirty ? DISABLED_BUTTON : PRIMARY_BUTTON}
              >
                Update
              </CustomButton>
            </Grid>
          </Grid>
          {keyPeople.length === 0 ? (
            <Box>
              <Box>
                <CustomButton onClick={handleAddContact} type={PRIMARY_BUTTON} sx={sx.buttonContact}>
                  Add a Contact
                </CustomButton>
              </Box>
            </Box>
          ) : (
            <>
              <Grid container>
                <Grid item xs={8}>
                  <Box sx={sx.list}>
                    {formik.values.map((item, index) => (
                      <Box sx={sx.keyPeople} key={index}>
                        <Box
                          display="flex"
                          justifyContent="space-between"
                          alignItems="center"
                          sx={{ borderBottom: '2px solid #25245F', marginBottom: '30px' }}
                        >
                          <Box sx={sx.contactLabel}>
                            <div>CONTACT ({index + 1})</div>
                          </Box>
                          <Box
                            fontSize={14}
                            fontWeight={700}
                            color="#D14343"
                            // onClick={handleDelete}
                            onClick={e => onRemoveContact(e, item)}
                            sx={{
                              textDecoration: 'underline',
                              cursor: 'pointer',
                            }}
                          >
                            Delete
                          </Box>
                        </Box>
                        <Grid container spacing={4}>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              label="Full Name"
                              variant="standard"
                              focused
                              name={`[${index}].firstName`}
                              value={item.firstName}
                              onKeyDown={handleDataChange}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={formik.errors[index]?.firstName}
                              helperText={formik.errors[index]?.firstName}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <Autocomplete
                              options={titles}
                              name={`[${index}].title`}
                              value={item.title}
                              onChange={(e, value) => {
                                handleChange(`[${index}].title`, value)
                              }}
                              onBlur={formik.handleBlur}
                              renderInput={params => (
                                <TextField {...params} variant="standard" label="Position Title" focused />
                              )}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              label="Email"
                              variant="standard"
                              focused
                              name={`[${index}].email`}
                              value={item.email}
                              onKeyDown={handleDataChange}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={formik.errors[index]?.email}
                              helperText={formik.errors[index]?.email}
                            />
                          </Grid>
                          <Grid item xs={6}>
                            <TextField
                              fullWidth
                              label="Phone Number"
                              variant="standard"
                              focused
                              name={`[${index}].phone`}
                              value={item.phone}
                              onKeyDown={handleDataChange}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              error={formik.errors[index]?.phone}
                              helperText={formik.errors[index]?.phone}
                            />
                          </Grid>
                        </Grid>
                        <Box display="flex" justifyContent="space-between" alignItems="center" marginTop="20px">
                          <FormControlLabel
                            sx={sx.checkboxLabel}
                            control={
                              <Checkbox
                                name={`[${index}].displayInDirectory`}
                                defaultChecked={item.displayInDirectory === true}
                                onClick={handleDataChange}
                                onChange={formik.handleChange}
                                value={true}
                                sx={{ '& .MuiSvgIcon-root': { fontSize: 20 } }}
                              />
                            }
                            label="Display in Directory"
                          />
                        </Box>
                      </Box>
                    ))}
                    <Box display="flex" justifyContent="space-between" alignItems="center">
                      <Button
                        onClick={handleAddContact}
                        variant="outlined"
                        startIcon={<AddCircleOutlineIcon />}
                        sx={sx.btnAdd}
                      >
                        Add a Contact
                      </Button>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={4}></Grid>
              </Grid>
              {showRemoveConfirmPopup && (
                <ConfirmDialog
                  show={showRemoveConfirmPopup}
                  setShow={() => setShowRemoveConfirmPopup(false)}
                  onSuccess={deleteHandler}
                  SuccessMessage="Remove"
                  title="Are You Sure?"
                  content="Do you want to proceed with removing the contact?"
                />
              )}
            </>
          )}
          <Box sx={{ marginTop: '100px' }}>
            <ZendeskLink />
          </Box>
          {snackData.isOpen && <Snackbar isOpen={true} type={snackData.type} message={snackData.message} />}
        </Box>
      )}
    </>
  )
}
